/** Accent colour for anchors, handles and the pen-edit hover highlights. */
export const NODE_ACCENT_COLOR = '#0284C7'
